export const environment = {
    development: true,
    apiUrl:'https://ninaws.ninaserver.com',
    usersApiUrl:'https://nina-payment.solidusystems.mx',
    photosUrl:'https://www.ninapasteleria.com/fotos/producto/',
    myModule:'https://ninaws.ninaserver.com',
    apiKey:'E7C8C0B789CB43F9BD7B596D35F9E377',
    agm_apikey:'AIzaSyDIoqddAnBJfCNCyZ_66cjHl3inD23thd0',
    stripe_apikey:'pk_test_51OKS2HGjXieTNdSKihlfoacdOPIgSKFPBYtRa8e9zeciCE0RtxfViX8PN52ON5a36caZBWOS14OXmYns5lzA3Gli001YeMslpM',
    guestEmail:"guest@solidusystems.com",
    guestPassword:"guest.pass",
    urlFacturacion:"https://testcfdi.ninapasteleria.com/frmwfacturar/?id=",
    ga4_measurement_id: 'GT-NGKVG5JF'
};

// export const environment = {
//     apiUrl:'https://ninaappi.com',
//     usersApiUrl:'https://api.ninapasteleria.app',
//     photosUrl:'https://www.ninapasteleria.com/fotos/producto/',
//     myModule:'https://appnina.ninaserverapi.com',
//     apiKey:'nInAO3PWJ20ew7dnDtZUfSCEUShNInVUphRc',
//     agm_apikey:'AIzaSyBke-mKcgE977uCBLfrSPDFmqOvHXlLyHU',
//     stripe_apikey:'pk_live_51PK7oKP9fZMXhh6JPs13gv9WfRAkfWqUefjqEQBxwjQZEP4B9eEVyY1gtH2SNvnZCbWVt4id9j400ATCQy0VRlO7006Nnld2wv',
//     guestEmail:"guest@solidusystems.com",
//     guestPassword:"guest.pass",
//     urlFacturacion:"https://facturacion.ninapasteleria.com/frmwFacturar/?id=",
//     ga4_measurement_id: 'GT-NGKVG5JF'
// };
